import { Component, OnInit, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-input-box',
    templateUrl: './input-box.component.html',
    styles: [],
    standalone: false
})
export class InputBoxComponent implements OnInit {
  @Input() public title: string;
  @Input() public prompt: string;
  @Input() public acceptButtonCaption: string = "OK";
  @Input() public cancelButtonCaption: string = "Cancel";
  @Input("max-length") public maxLength: string = "100";
  @Output() public valueText: EventEmitter<string> = new EventEmitter();

  @ViewChild("inputBox") inputBox: TemplateRef<any> = {} as TemplateRef<any>;

  public inputForm: UntypedFormGroup;
  public modalRef: NgbModalRef;

  public get inputText() {
    return this.inputForm.get("inputText");
  }

  constructor(private modalService: NgbModal, private fb:UntypedFormBuilder) { }

  public ngOnInit(): void {
    this.inputForm = this.fb.group({
      inputText: ["", [Validators.required]]
    });
  }

  public open(): void {
    this.inputText.setValue("");
    this.inputText.markAsUntouched();
    this.modalRef = this.modalService.open(this.inputBox);
  }

  public onSubmit(): void {
    this.modalRef.close();
    this.valueText.emit(this.inputText.value.trim());
  }
}
